export const galleryOptions = {
    on: {
        initCarousel: (fancybox) => {
            const title = fancybox.getOptions().triggerEl ? fancybox.getOptions().triggerEl.dataset.title : null;
            const carouselEl = fancybox.getContainer().querySelector('.fancybox__carousel');

            if (title) {
                const titleEl = document.createElement('div');
                titleEl.classList.add('fancybox__title');
                if (title) titleEl.textContent = title;

                setTimeout(() => {
                    carouselEl.prepend(titleEl);
                }, 0);
            }
        },
    },
    Carousel: {
        Toolbar: {
            display: {
                left: [],
                middle: [],
                right: ["close"],
            },
        },
    },
}

export default galleryOptions;